export default __webpack_public_path__ + "static/media/crab.08d9c258.png";